module.exports = __webpack_public_path__ + "static/media/search-icon.40a39212.svg";